import React from 'react';
import { Switch, Route, useRouteMatch } from 'react-router-dom';
import { Pages } from "components/pages";


export default function CompaniesRoute() {

    const { path } = useRouteMatch();

    return (
        <Switch>
            <Route path={ `${ path }` } exact>
                <Pages.Companies />
            </Route>
            <Route path={ `${ path }/page/:pageNum` } exact>
                <Pages.Companies />
            </Route>
            <Route path={ `${ path }/page` } exact>
                <Pages.Companies />
            </Route>
            <Route path={ `${ path }/:id` } >
                { ({ match, history }) => <Pages.Company match={ match } history={ history } exact /> }
            </Route>
            <Route path={ `${ path }/create` } exact>
                <Pages.Company />
            </Route>
        </Switch>
    );
}

